<header class="header">
  <!-- Left: breadcrumb -->
  <nav class="header__breadcrumbs" aria-label="Breadcrumb">
    <a routerLink="/" class="header__crumb-link">Home</a>
    <app-icon name="chevron-right" [size]="12" class="header__crumb-sep" />
    <span class="header__crumb-active">{{ currentPageName() }}</span>
  </nav>

  <!-- Right: actions -->
  <div class="header__right">
    <button class="header__icon-btn" aria-label="Notifications">
      <app-icon name="bell" [size]="15" />
    </button>
    <button class="header__icon-btn" aria-label="Calendar">
      <app-icon name="calendar" [size]="15" />
    </button>
    <div class="header__separator"></div>
    <app-avatar [imageUrl]="avatarUrl()" [initials]="profile().initials" [size]="32" />
  </div>
</header>
